var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-popover",
    {
      attrs: { placement: "bottom", width: "336", trigger: "click" },
      on: { show: _vm.getUserPointData },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-reward" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-reward__header" },
          [
            _c("div", [
              _c("img", {
                staticClass: "yxtbiz-reward__header--avatar",
                attrs: { src: _vm.targetUser.imgUrl || _vm.defaultAvatar },
              }),
              _c(
                "span",
                { staticClass: "color-gray-10 font-bolder font-size-16" },
                [
                  _c("yxtbiz-user-name", {
                    attrs: { name: _vm.targetUser.fullname },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "yxtf-row",
              {
                staticClass: "color-gray-7",
                attrs: { type: "flex", align: "middle" },
              },
              [
                _c("span", { staticClass: "standard-size-14" }, [
                  _vm._v("收到"),
                ]),
                _c("yxt-svg", {
                  staticStyle: { margin: "0 5px" },
                  attrs: {
                    iconClass: "point",
                    "remote-url": _vm.mediaPath,
                    width: "16px",
                    height: "16px",
                  },
                }),
                _c("span", { staticClass: "standard-size-14" }, [
                  _vm._v(_vm._s(_vm.targetUser.totalMallPoint)),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "ul",
          {
            staticClass:
              "yxtbiz-reward__main standard-size-16 font-bolder color-gray-8",
          },
          [
            _vm._l(_vm.points, function (point, index) {
              return _c(
                "li",
                {
                  key: point,
                  staticClass: "yxtbiz-reward--item",
                  class: {
                    "active border-primary-6": _vm.currentIndex === index,
                  },
                  on: {
                    click: function ($event) {
                      _vm.currentIndex = index
                    },
                  },
                },
                [_vm._v(_vm._s(point) + "\n        ")]
              )
            }),
            _c(
              "li",
              { staticClass: "yxtbiz-reward--item" },
              [
                _c("yxtf-input", {
                  attrs: {
                    oninput: "value=value.replace(/[^\\d.]/g,'')",
                    maxlength: "4",
                    placeholder: "输入数额",
                  },
                  on: {
                    focus: function ($event) {
                      _vm.currentIndex = null
                    },
                  },
                  model: {
                    value: _vm.customPoint,
                    callback: function ($$v) {
                      _vm.customPoint = _vm._n(
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "customPoint",
                  },
                }),
              ],
              1
            ),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "yxtbiz-reward__footer" },
          [
            _c("span", { staticClass: "color-gray-7 standard-size-14" }, [
              _vm._v("您的可用积分为：" + _vm._s(_vm.totalMallPoint)),
            ]),
            _c(
              "yxt-button",
              {
                attrs: { type: "primary", disabled: !_vm.disabled },
                on: { click: _vm.save },
              },
              [_vm._v("打赏")]
            ),
          ],
          1
        ),
      ]),
      _vm._t("default", null, { slot: "reference" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }